import type { JSX } from 'react';

const WebhooksEmptyState = (): JSX.Element => {
  return (
    <div className="mt-4 rounded-lg border border-border-subtle bg-bg-surface px-4 py-6 text-center text-sm text-text-muted font-body">
      <p className="m-0 font-medium text-text-default">No hay webhooks configurados</p>
      <p className="m-0 mt-2">
        Pulsa <strong>Nuevo webhook</strong> para crear uno o hazlo desde el centro partner.
      </p>
    </div>
  );
};

export default WebhooksEmptyState;
